import { useState } from "react";
import Link from "next/link";
import clsx from "clsx";
import { PARTNER_IDS } from "@chef/constants";
import { Input, Button } from "@chef/components";
import { useAppDispatch, useAppSelector } from "@chef/state-management/hooks";
import { language } from "@chef/constants";
import { getPartnership, setPartnership } from "@chef/state-management";
import { isEqualStrings } from "@chef/utils/equal";

const intl = {
  no: {
    EUROBONUS_NUMBER: "Eurobonus-nummer",
  },
  se: {
    EUROBONUS_NUMBER: "Eurobonus-nummer",
  },
  dk: {
    EUROBONUS_NUMBER: "Eurobonus-nummer",
  },
};

export interface EurobonusComponentProps {
  value: {
    text: string;
    href: string;
  };
}

export const EurobonusComponent = ({
  value: { text, href },
}: EurobonusComponentProps) => {
  const dispatch = useAppDispatch();
  const eurobonusPartnership = useAppSelector((state) =>
    getPartnership(state.signupRtk.partnerships, PARTNER_IDS.EUROBONUS),
  );
  const [eurobonusNumber, _setEurobonusNumber] = useState("");
  const EUROBONUS_NUMBER_LENGTH = 9;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    _setEurobonusNumber(numericValue);
  };

  const validateEurobonusNumber = () => {
    const paddedNumber = eurobonusNumber.padStart(EUROBONUS_NUMBER_LENGTH, "0");

    dispatch(
      setPartnership({
        partnerId: PARTNER_IDS.EUROBONUS,
        customerReference: paddedNumber,
      }),
    );
  };

  const isValid =
    eurobonusNumber.length > 0 &&
    !isEqualStrings(
      eurobonusNumber.padStart(EUROBONUS_NUMBER_LENGTH, "0"),
      "000000000",
    );

  return (
    <div className="flex flex-col gap-4">
      <Input
        placeholder={intl[language].EUROBONUS_NUMBER}
        name="eurobonusNumber"
        id="eurobonusNumber"
        value={eurobonusNumber}
        onChange={handleInputChange}
        showLengthCounter={false}
        maxLength={EUROBONUS_NUMBER_LENGTH}
        valid={!!eurobonusPartnership}
      />
      <Link
        href={isValid ? href : "#"}
        className={clsx("w-full md:w-auto md:self-center", "no-underline")}
        passHref
      >
        <Button
          primary
          className="w-full"
          onClick={validateEurobonusNumber}
          disabled={!isValid}
        >
          {text}
        </Button>
      </Link>
    </div>
  );
};
